import { Button, Dropdown, MenuProps, Popconfirm, Space } from "antd";
import { ServiceContractDebitsComponent } from "src/features/ServiceContractDebit/ServiceContractDebitsComponent"
import { DownOutlined, SendOutlined } from '@ant-design/icons';

import * as Styles from "./styles"
import { useDispatch, useSelector } from "react-redux";
import { sendAccountBalanceApi } from "../../state/action";
import { useParams } from "react-router-dom";
import { RootState } from "src/state/reducer";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { SEND_ACCOUNT_BALANCE_API } from "../../state/actionTypes";
import { Loader } from "src/components/Loader";
import { SystemDescriptions } from "src/common/descriptions";

export type ReduxProps = {
    isSendingAccountBalance: boolean
    sendAccountBalanceSuccess?: boolean
}

export const CustomerAccountPayables = () => {
    const dispatch = useDispatch()

    const { id: customerId } = useParams<{ id: string }>();

    const reduxProps: ReduxProps = useSelector((state: RootState) => {
        return ({
            sendAccountBalanceSuccess: state.customer.sendAccountBalanceSuccess,
            isSendingAccountBalance: serviceLoading(state, [SEND_ACCOUNT_BALANCE_API]),
        })
    })

    const descriptions = SystemDescriptions.PAGES.CUSTOMER.CUSTOMER_PROFILE
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const handleCancel = () => { }

    const handleOk = () => {
        if (!customerId) return

        dispatch(sendAccountBalanceApi(Number(customerId)))
    }

    const items: MenuProps['items'] = [
        {
            key: 'SEND_ACCOUNT_BALANCE',
            label: (
                <Popconfirm
                    placement="topLeft"
                    title={descriptions.TABS.CUSTOMER_ACCOUNT_PAYABLES.OPTIONS.SEND_ACCOUNT_BALANCE.CONFIRMATION}
                    description={""}
                    okText={commonDescriptions.YES}
                    cancelText={commonDescriptions.NO}
                    onConfirm={handleOk}
                    onCancel={handleCancel}
                >
                    <a
                        rel="noopener noreferrer">
                        <SendOutlined /> {descriptions.TABS.CUSTOMER_ACCOUNT_PAYABLES.OPTIONS.SEND_ACCOUNT_BALANCE.TITLE}
                    </a>
                </Popconfirm>
            ),
        },
    ];

    const renderLoader = () => (
        <Loader
            isVisible={reduxProps.isSendingAccountBalance}
            title={descriptions.TABS.CUSTOMER_ACCOUNT_PAYABLES.OPTIONS.SEND_ACCOUNT_BALANCE.LOADING_TITLE}
            description={descriptions.TABS.CUSTOMER_ACCOUNT_PAYABLES.OPTIONS.SEND_ACCOUNT_BALANCE.LOADING_DESCRIPTION}
        />
    )

    return (
        <>
            <Styles.TitleContainer>
                <Styles.Title>{descriptions.TABS.CUSTOMER_ACCOUNT_PAYABLES.TITLE}</Styles.Title>
                <Dropdown menu={{ items }} placement="bottomRight" arrow={{ pointAtCenter: true }}>
                    <Button>
                        <Space>
                            {descriptions.TABS.OPTIONS}
                            <DownOutlined />
                        </Space>
                    </Button>
                </Dropdown>
            </Styles.TitleContainer>
            <ServiceContractDebitsComponent />
            {renderLoader()}
        </>
    )
}
